import { PlatformInformation } from '@/types';

export async function requestPlatformInformation() {
  return new Promise<PlatformInformation>((resolve, reject) => {
    if (!window.platformInformation && !window.flutter_inappwebview) {
      return reject();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function handleResponse(this: Window, event: MessageEvent<any>) {
      // neha rossz valasz jon, pl az elmentett jelszo...
      // FIXME ha ezt a dolgot a flutter kitoltene defaultbol akkor nem kellene ez a kommunikacio
      if (event.data.length < 2 || event.data[0] !== 'platformInformation') {
        return;
      }

      cleanup();
      resolve(event.data[1]);
    }

    function cleanup() {
      clearTimeout(timeout);
      window.removeEventListener('message', handleResponse);
    }

    const timeout = setTimeout(() => {
      cleanup();
      reject(new Error('timeout'));
    }, 500);

    window.addEventListener('message', handleResponse);
    if (window.platformInformation) {
      window.platformInformation.postMessage('');
    }
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler('platformInformation', '');
    }
  });
}
